<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfmf"><a class="xref" href="#/chigunn0010#pre">Preambling toward Profligacy</a></p>
<p class="tocf"><a class="xref" href="#/chigunn0011#intro">Introduction: Eating Poorly, or Ketchup on a Steak</a></p>
<p class="toc"><a class="xref" href="#/chigunn0012#ch01">1   On Critical Violence</a></p>
<p class="toc"><a class="xref" href="#/chigunn0013#ch02">2   The Psychoses of Speed, with the Example of Social Networking</a></p>
<p class="toc"><a class="xref" href="#/chigunn0014#ch03">3   The Perverse Style, with Eventual Reference to Pee-wee Herman</a></p>
<p class="toc"><a class="xref" href="#/chigunn0015#ch04">4   Showmancing the Presidency: Perverse Genres and the Problem of Judgment</a></p>
<p class="toc"><a class="xref" href="#/chigunn0016#conc">Conclusion: Don’t Play (with) That</a></p>
<p class="tocbmf"><a class="xref" href="#/chigunn0017#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chigunn0018#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chigunn0020#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-gunn-0008.vue?825f5e50